// @ts-nocheck - fix me
import { Spacer } from '@components';
import { InternationalPhoneInput } from '@/screens/components/InternationalPhoneInput';
import AppConfig from '@config';
import useLocalization, { TranslationKey } from '@localizations';
import { dispatchUpdateCompany, processError, useAppStore } from '@store';
import { LoginContactLogo } from '@svgs';
import { FunctionComponent, useState } from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input/max';
import { Text, View } from 'react-native';
import { HelperText, TextInput, useTheme } from 'react-native-paper';
import { ButtonView, ContentView, HeaderView } from './Common';
import { LoginStyles } from './Styles';

interface IFormErrors {
  name: TranslationKey | null;
  email: TranslationKey | null;
  phone: TranslationKey | null;
  api: string | null;
}

interface IFormProps {
  formErrors: IFormErrors;
  name: string;
  setName: (name: string) => void;
  email: string;
  setEmail: (email: string) => void;
  phone: string;
  setPhone: (phone: string) => void;
}

// @@ Form View
const FormView: FunctionComponent<IFormProps> = ({
  formErrors,
  name,
  setName,
  email,
  setEmail,
  phone,
  setPhone,
}) => {
  const { t } = useLocalization();
  return (
    <View
      style={[{ justifyContent: 'space-between' }, AppConfig.Styles.fullWidth]}>
      <TextInput
        style={{
          height: AppConfig.Styles.inputHeight,
        }}
        mode="outlined"
        label={t('name')}
        value={name}
        onChangeText={text => setName(text)}
      />
      <HelperText type="error" visible={formErrors.name !== null}>
        {t(formErrors.name ?? 'validation_required')}
      </HelperText>
      <Spacer size={1} />
      <TextInput
        style={{
          height: AppConfig.Styles.inputHeight,
        }}
        mode="outlined"
        label={t('web_login_email')}
        value={email}
        onChangeText={text => setEmail(text)}
      />
      <HelperText type="error" visible={formErrors.email !== null}>
        {t(formErrors.email ?? 'validation_required')}
      </HelperText>
      <Spacer size={1} />
      <View style={{ flexDirection: 'row', width: '100%' }}>
        <InternationalPhoneInput
          value={phone}
          onChange={setPhone}
          error={formErrors.phone !== null}
          label={t('phone_number')}
        />
      </View>
      <HelperText type="error" visible={formErrors.phone !== null}>
        {t(formErrors.phone ?? 'validation_required')}
      </HelperText>
      <HelperText type="error" visible={formErrors.api !== null}>
        {formErrors.api || t('generic_error')}
      </HelperText>
      <Text
        style={[AppConfig.Styles.caption, AppConfig.Styles.textAlignCenter]}>
        {t('information_disclaimer')}
      </Text>
    </View>
  );
};
// @@ Default Component
export const Contact = () => {
  const { t } = useLocalization();
  const themeProvider = useTheme();
  const { company, reservation, theme } = useAppStore();
  const [name, setName] = useState(reservation?.guestName ?? '');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState<IFormErrors>({
    name: null,
    email: null,
    phone: null,
    api: null,
  });
  const submit = async () => {
    // Verification - there needs to be a better way
    const newErrors: IFormErrors = {
      name: name.length === 0 ? 'validation_required' : null,
      email: email.length === 0 ? 'validation_required' : null,
      phone: phone.length === 0 ? 'validation_required' : null,
      api: null,
    };

    // Additional email regex
    if (newErrors.email === null && !/.+@.+\..+/.test(email)) {
      newErrors.email = 'invalid_email_message';
    }

    // check if phone number is valid
    if (
      !isValidPhoneNumber(phone) &&
      newErrors.phone !== 'validation_required'
    ) {
      newErrors.phone = 'invalid_phone_message';
    }

    // Set the form errors and stop submission
    if (Object.values(newErrors).some(error => error !== null)) {
      setFormErrors(newErrors);
      return false;
    }

    setLoading(true);
    try {
      dispatchUpdateCompany({
        ...company,
        reservation: {
          ...reservation,
          guestName: name,
          guestEmail: email,
          guestPhone: phone,
          termsAgreed: true,
        },
      });

      return true;
    } catch (error) {
      const message = processError(error);
      setFormErrors({ ...newErrors, api: message });
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <View style={[AppConfig.Styles.container, AppConfig.Styles.center]}>
      <View style={[AppConfig.Styles.container, LoginStyles.container]}>
        <View style={[LoginStyles.contentContainer]}>
          <ContentView
            title={t('step_three_title')}
            description={t('step_three_subtitle')}>
            <HeaderView theme={theme} />
            {theme?.welcomeImagesEnabled && (
              <LoginContactLogo
                style={{ color: themeProvider.colors.primary }}
                width={AppConfig.Styles.getAdjustedSize(230)}
              />
            )}
          </ContentView>
          <Spacer size={3} />
          <FormView
            name={name}
            setName={setName}
            email={email}
            setEmail={setEmail}
            phone={phone}
            setPhone={setPhone}
            formErrors={formErrors}
          />
          <Spacer size={3} />
          <View style={{ width: '100%' }}>
            <ButtonView
              onSubmit={submit}
              company={company}
              loading={loading}
              currentPage="Contact"
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default Contact;
